export enum DesignType {
  CARDS = 'cards',
  BULLETS = 'bullets',
}

export enum ViewType {
  LIST = 'list',
  GRID = 'grid',
}
